var ModalRendering = function() {
    var htmlModalTemplate = function(id, body, title, subtitle, extraModalClassesStr, extraHeaderClassesStr, extraBodyClassesStr) {
        subtitle = Util.defaultFor(subtitle, false);
        extraModalClassesStr = Util.defaultFor(extraModalClassesStr, '');
        extraHeaderClassesStr = Util.defaultFor(extraHeaderClassesStr, '');
        extraBodyClassesStr = Util.defaultFor(extraBodyClassesStr, '');
        return '\
            <div class="modal fade ' + extraModalClassesStr + '" id="' + id + '" tabindex="-1" role="dialog" aria-hidden="true" aria-labelledby="' + id + '_label">\
                <div class="modal-dialog modal-dialog-centered">\
                    <div class="modal-content">\
                        <div class="modal-header py-3 ' + extraHeaderClassesStr + '">\
                            <a href="javascript:void(0);" class="modal-close close" data-dismiss="modal" aria-label="Close">\
                                <i class="far fa-times"></i>\
                            </a>\
                            <h5 class="modal-title title" id="' + id + '_label">' + title + '</h5>'
                            + (subtitle ? '<p class="text mb-0">' + subtitle + '</p>' : '') + '\
                        </div>\
                        <div class="modal-body ' + extraBodyClassesStr + '" id="' + id + '_body">'
                            + body + '\
                        </div>\
                    </div>\
                </div>\
            </div>\
        ';
    };

    return {
        htmlConfirmModal: function(data) {
            var modalBody;
            if (data.rawBody) {
                modalBody = data.body;
            } else {
                modalBody = '\
                    <div class="d-flex justify-content-end mb-3">\
                        <p class="mr-auto">' + data.body + '</p>\
                    </div>\
                ';
            }
            modalBody += '\
                <div class="btn-wrap justify-content-end">\
                    <button class="btn btn-primary ml-1 ml-md-0" id="generic-confirm-ok-btn" data-dismiss="modal">\
                        <span>OK</span>\
                        <i class="icon fas fa-angle-right"></i>\
                    </button>\
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">\
                        <span>ΑΚΥΡΟ</span>\
                        <i class="icon fas fa-angle-right"></i>\
                    </button>\
                </div>\
            ';
            return htmlModalTemplate('generic-confirm-modal', modalBody, data.title);
        },
        htmlAlertModal: function(data) {
            var modalBody;
            if (data.rawBody) {
                modalBody = data.body;
            } else {
                modalBody = '\
                    <div class="d-flex justify-content-end mb-3">\
                        <p class="mr-auto">' + data.body + '</p>\
                    </div>\
                ';
            }
            modalBody += '\
                <div class="btn-wrap justify-content-end">\
                    <button class="btn btn-primary ml-1 ml-md-0" data-dismiss="modal">\
                        <span>OK</span>\
                        <i class="icon fas fa-angle-right"></i>\
                    </button>\
                </div>\
            ';
            return htmlModalTemplate('generic-alert-modal', modalBody, data.title);
        },
        htmlSMSTrialModal: function() {
            return htmlModalTemplate(
                'sms_trial_modal',
                '\
                    <div class="d-flex flex-column align-content-center flex-wrap">\
                        <p class="mb-2">\
                            Συμπλήρωσε το κινητό σου για να λάβεις δωρεάν έναν κωδικό δοκιμής:\
                        </p>\
                        <div class="form-group form-group--xl" id="phone_wrapper">\
                            <label for="phonenumber">ΤΗΛΕΦΩΝΟ:</label>\
                            <input type="text" class="form-control" name="phonenumber" id="phonenumber" value="">\
                        </div>\
                        <div class="btn-wrap justify-content-between mb-2">\
                            <div id="phone_response" class="clr-red"></div>\
                            <button type="button" id="submit_phonenumber_btn" class="btn btn-primary btn--xs">\
                            <span>ΥΠΟΒΟΛΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                            </button>\
                        </div>\
                        <p class="mb-2">Όταν λάβεις τον κωδικό συμπλήρωσέ τον εδώ:</p>\
                        <div class="form-group form-group--xl" id="code_wrapper">\
                            <label for="smspin">ΚΩΔΙΚΟΣ:</label>\
                            <input type="text" class="form-control" name="smspin" id="smspin" value="">\
                        </div>\
                        <div class="btn-wrap justify-content-between mb-3">\
                            <div id="sms_trial_response" class="clr-red"></div>\
                            <button type="button" id="submit_smspin_btn" class="btn btn-primary btn--xs">\
                            <span>ΥΠΟΒΟΛΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                            </button>\
                        </div>\
                        <i class="mb-3">Σημείωση: Δε θα σου στείλουμε ποτέ άλλο SMS πέρα από τον κωδικό. Η υπηρεσία απευθύνεται αποκλειστικά σε ενήλικες.</i>\
                        <div class="btn-wrap justify-content-end">\
                            <button type="button" class="btn btn-secondary btn--xs" data-dismiss="modal">\
                                <span>ΚΛΕΙΣΙΜΟ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                            </button>\
                        </div>\
                    </div>\
                ',
                'ΔΩΡΕΑΝ ΔΟΚΙΜΗ'
            );
        },
        htmlFQueuePremiumModal: function(data) {
            return htmlModalTemplate(
                'fqueue_premium_modal',
                '\
                    <p style="margin-bottom:0px;">\
                        <strong>' +
                            data.totalFStat + ' μέλη του Blindchat περιμένουν να σε γνωρίσουν. ' + data.onlineFStat + ' είναι online αυτή τη στιγμή!\
                        </strong>\
                    </p>\
                    <div class="btn-wrap justify-content-center">' +
                        (
                            Common.serving_app ?
                            '<a href="javascript:void(0);" class="ii__premium_btn btn btn-primary btn--sm my-4 px-4" data-dismiss="modal">Γίνε PREMIUM</a>' :
                            '<a href="javascript:void(0);" class="ii__premium_modal_btn btn btn-primary btn--sm my-4 px-4" data-dismiss="modal" data-ref="trial_queue_modal">Γίνε PREMIUM</a>'
                        ) + '\
                    </div>\
                    <ul class="list-check">\
                        <li>Γίνε premium χρήστης και μίλα όσες φορές θέλεις!</li>\
                        <li>Αντάλλαξε φωτογραφίες, κάνε βίντεο-κλήσεις και δημιούργησε απεριόριστες νέες επαφές!</li>\
                        <li>Πέρνα στον επόμενο συνομιλητή ανά πάσα στιγμή, με το πάτημα ενός κουμπιού!</li>\
                        <li>Διατήρησε πλήρως την ανωνυμία σου.</li>\
                    </ul>\
                    <p class="my-3">\
                        Αν είσαι καινούριος χρήστης και θέλεις να το δοκιμάσεις εντελώς δωρεάν\
                        <a href="javascript:void(0);" data-dismiss="modal" id="trial_modal_show_btn"><u>πάτησε εδώ</u></a>.\
                    </p>\
                    <div class="btn-wrap justify-content-end">\
                        <button type="button" class="btn btn-secondary btn--xs" data-dismiss="modal">\
                            <span>ΚΛΕΙΣΙΜΟ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                    </div>\
                ',
                'ΑΝ ΗΣΟΥΝ PREMIUM ΧΡΗΣΤΗΣ ΤΩΡΑ ΘΑ ΞΕΚΙΝΟΥΣΕ Η ΣΥΝΟΜΙΛΙΑ ΣΟΥ'
            );
        },
        htmlReceivedHistoryFriendModal: function(data) {
            return htmlModalTemplate(
                'received_history_friend_modal',
                '\
                    <div class="d-flex flex-column align-content-center flex-wrap">\
                        <div class="history-wrap">\
                            <div class="history history--clean">\
                                <div class="history__content">\
                                    <div class="outline">' +
                                        data.messagesFormatted + '\
                                    </div>\
                                </div>\
                            </div>\
                        </div>\
                        <div class="btn-wrap justify-content-between">\
                            <button type="button" class="btn btn-secondary" id="received_history_friend_reject_btn" data-uid="' + data.friendID + '">\
                                <span>ΑΠΟΡΡΙΨΗ</span>\
                            </button>\
                            <button type="button" id="received_history_friend_accept_btn" class="btn btn-primary" data-uid="' + data.friendID + '">\
                                <span>ΑΠΟΔΟΧΗ</span>\
                            </button>\
                        </div>\
                    </div>\
                ',
                'Ένας παλαιότερος συνομιλητής σου θέλει να σε προσθέσει στους φίλους του'
            );
        },
        htmlPremiumEndingModal: function(data) {
            return htmlModalTemplate(
                'premium_ending_modal',
                '\
                    <p>\
                        Σε ενημερώνουμε πως η συνδρομή σου λήγει στις ' + data.premiumUntil + '.\
                        Αν επιθυμείς να την ανανεώσεις <a href="javascript:void(0);" class="ii__premium_modal_btn" data-ref="renew" data-dismiss="modal"><u>πάτησε εδώ</u></a>.\
                    </p>\
                    <div class="btn-wrap justify-content-end">\
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">\
                            <span>ΚΛΕΙΣΙΜΟ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                    </div>\
                ',
                'ΛΗΞΗ PREMIUM ΣΥΝΔΡΟΜΗΣ'
            );
        },
        htmlEmailVerifyModal: function(data) {
            return htmlModalTemplate(
                'email_verify_modal',
                '\
                    <div class="form-group form-group--xl" id="email_wrapper">\
                        <label for="email_input">E-MAIL:</label>\
                        <input type="text" class="form-control" name="email_input" id="email_input" value="' + data.email + '">\
                    </div>\
                    <div class="btn-wrap justify-content-start">\
                        <button type="button" id="submit_email_btn" class="btn btn-primary">\
                            <span>ΑΠΟΘΗΚΕΥΣΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                    </div>\
                    <div class="btn-wrap justify-content-end">\
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">\
                            <span>ΚΛΕΙΣΙΜΟ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                    </div>\
                ',
                'Επιβεβαίωση e-mail',
                'Παρακαλούμε βεβαιωθείτε ότι το e-mail που έχετε δώσει είναι έγκυρο, για να μπορείτε στο μέλλον να ανακτήσετε τον κωδικό σας.'
            );
        },
        htmlPromoBanner: function(data) {
            return htmlModalTemplate(
                'android_promo_modal',
                '\
                    <div class="banner-row">\
                        <div class="banner-icon-withinfo">\
                            <img src="' + data.logoSRC + '" class="banner-icon">\
                            <div class="banner-info">\
                                <a href="' + data.link + '" target="_blank" class="banner-title">\
                                    Blindchat\
                                </a>\
                                <br>\
                                <span>Official App</span><br>\
                                <span>Δωρεάν - ' + data.store + '<span>\
                            </div>\
                        </div>\
                        <a href="' + data.link + '" target="_blank" class="btn btn-primary btn--xs px-3">\
                            <span>ΛΗΨΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </a>\
                    </div>\
                ',
                'ΔΟΚΙΜΑΣΤΕ ΤΟ ΝΕΟ BLINDCHAT APP'
            );
        },
        htmlSmsPaymentModal: function(data) {
            return htmlModalTemplate(
                'sms_payment_modal',
                '\
                    <div class="form-content">\
                        <p class="text mb-2">\
                            Στείλε SMS με τη λέξη <b>TET στο 54111</b> (4.01 ευρώ για 24 ώρες)\
                        </p>\
                        <p class="text mb-0">\
                            Αν έστειλες SMS βάλε εδώ το PIN:\
                        </p>\
                        <div class="form-group form-group--xl">\
                            <label>PIN:</label>\
                            <input id="sms_pin" type="text" class="form-control">\
                        </div>\
                        <div style="height: 22px;"><div id="sms_response" class="clr-red" style="display:none;">Μη έγκυρο PIN</div></div>\
                        <p class="text mb-2">Αν έστειλες SMS και δεν έλαβες το pin <a href="/pin"><u>πάτησε εδώ για να σου το ξαναστείλουμε</u></a>.</p>\
                        <p class="text mb-1">\
                            Σημείωση: Δεν αποτελεί συνδρομητική υπηρεσία. Η χρέωση γίνεται μία μόνο φορά τη στιγμή που στέλνεις εσύ το μήνυμα.\
                            Απευθύνεται αποκλειστικά σε ενήλικες. Δρομολόγηση SMS: Newsphone Hellas.\
                            Χρέωση €4,01/SMS (με ΦΠΑ και τέλος κινητής τηλεφωνίας).\
                            Εξ. Πελατών 2109472166.\
                            <br>\
                            <a href="/faq/#support"><u>Επικοινωνήστε μαζί μας για βοήθεια</u></a>\
                        </p>\
                        <div class="btn-wrap justify-content-end py-3">\
                            <button type="button" class="btn btn-secondary" id="sms_modal_close_btn" data-ref="' + data.ref + '">\
                                <span>ΚΛΕΙΣΙΜΟ</span>\
                                <i class="icon fas fa-angle-right"></i>\
                            </button>\
                            <button id="redeem_sms_btn" type="button" class=" btn btn-primary" data-ref="' + data.ref + '">\
                                <span>ΥΠΟΒΟΛΗ</span>\
                                <i class="icon fas fa-angle-right"></i>\
                            </button>\
                        </div>\
                    </div>\
                ',
                'ΜΙΛΗΣΕ ΜΕ ΠΡΟΤΕΡΑΙΟΤΗΤΑ ΚΑΙ ΧΩΡΙΣ ΠΕΡΙΟΡΙΣΜΟΥΣ<br>ΓΙΝΕ ΜΕΛΟΣ ΤΟΥ PREMIUM CLUB',
                'Έτσι θα μιλάς όσες φορές θες και επίσης θα μπεις σε γραμμή προτεραιότητας για να μιλάς όσο πιο γρήγορα γίνεται.',
                'modal--sms'
            );
        },
        htmlPaymentsModal: function(data) {
            return htmlModalTemplate(
                'payments_modal',
                '\
                    <div class="modal-body modal-body--carousel">\
                        <div class="carousel carousel--modal">\
                            <div>\
                                <img data-lazy="' + data.premiumImg1Src + '" alt="" height="100">\
                                <h4 class="title title--alt">Μίλησε όσες φορές θέλεις</h4>\
                                <p>\
                                    χωρίς κανένα περιορισμό\
                                </p>\
                            </div>\
                            <div>\
                                <img data-lazy="' + data.premiumImg2Src + '" alt="" height="100">\
                                <h4 class="title title--alt">Προτεραιότητα στην ουρά</h4>\
                                <p>\
                                    με περιορισμένο χρόνο αναμονής\
                                </p>\
                            </div>\
                        </div>\
                    </div>\
                    <div class="modal-body modal-body--white modal-body--packages">\
                        <div class="package-wrap">\
                            <div class="package-wrap__item">\
                                <input type="radio" name="time" value="7" id="package-new04"' + (data.checked == '7' ? ' checked' : '') + '>\
                                <label for="package-new04" class="package">\
                                    <div class="package__block">\
                                        <h2 class="title">PREMIUM</h2>\
                                    </div>\
                                    <div class="package__block package__block--info">\
                                        <span>3</span>\
                                        <strong>ημέρες</strong>\
                                        <small>2.33&euro;/μέρα</small>\
                                    </div>\
                                    <div class="package__block">\
                                        <strong class="package__price">7&euro;</strong>\
                                    </div>\
                                </label>\
                            </div>\
                            <div class="package-wrap__item">\
                                <input type="radio" name="time" value="29" id="package-new02"' + (data.checked == '29' ? ' checked' : '') + '>\
                                <label for="package-new02" class="package">\
                                    <div class="package__block">\
                                        <h2 class="title">ΔΗΜΟΦΙΛΕΣ</h2>\
                                    </div>\
                                    <div class="package__block package__block--info">\
                                        <span>30</span>\
                                        <strong>ημέρες</strong>\
                                        <small>0.96&euro;/μέρα</small>\
                                    </div>\
                                    <div class="package__block">\
                                        <strong class="package__price">29&euro;</strong>\
                                    </div>\
                                </label>\
                            </div>\
                        </div>\
                        <div class="payments hide-hxs">' +
                            data.paymentMethodsImgsHtml +
                        '</div>' +
                        (Common.isLoggedin ? '<a href="/coupon">\
                            <small>Έχω κουπόνι Premium</small>\
                        </a>' : '') +
                        '<div class="btn-wrap btn-wrap--col">\
                            <button type="button" class="btn btn-primary" id="planbtn" data-dismiss="modal">\
                                <span>ΣΥΝΕΧΕΙΑ</span>\
                                <i class="icon fas fa-angle-right"></i>\
                            </button>\
                            <button type="button" class="btn btn--clean" data-dismiss="modal">ΚΛΕΙΣΙΜΟ</button>\
                        </div>\
                    </div>\
                ',
                'BLINDCHAT PREMIUM',
                '',
                'modal--payments',
                'modal-header--light',
                'p-0'
            );
        },
        htmlCouponModal: function(data) {
            return htmlModalTemplate(
                'coupon_received_modal',
                '\
                    <div>\
                        Έχεις διαθέσιμο ένα <strong>δωρεάν κουπόνι PREMIUM</strong> διάρκειας <strong>' + data.days +
                    ' ' + (data.days > 1 ? 'ημερών' : 'ημέρας') + '</strong>. Αν θέλεις να ξεκινήσεις τη χρήση του άμεσα, πατήσε <strong>ΕΦΑΡΜΟΓΗ</strong>. Διαφορετικά θα σε ρωτήσουμε πάλι στην επόμενη επίσκεψή σου.\
                    </div>' + (data.custom_text ? ('<div class="mt-3">' + data.custom_text + '</div>') : '') +
                    '<div class="btn-wrap justify-content-end mt-3">\
                        <button class="btn btn-primary btn--xs ml-1 ml-md-0 ii__coupon_apply" data-dismiss="modal"  data-cname="' + data.name + '">\
                            <span>ΕΦΑΡΜΟΓΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                        <button type="button" class="btn btn-secondary btn--xs" data-dismiss="modal">\
                            <span>ΑΠΟΚΡΥΨΗ</span>\
                            <i class="icon fas fa-angle-right"></i>\
                        </button>\
                    </div>\
                ',
                '🎉 ΔΩΡΕΑΝ ΚΟΥΠΟΝΙ PREMIUM'
            );
        },
        htmlHistoryFriendModal: function(data) {
            return htmlModalTemplate(
                'history_friend_modal',
                '\
                    <div class="d-flex flex-column align-content-center flex-wrap">\
                        <p>Γράψε ένα μήνυμα για να βοηθήσεις το συνομιλητή σου να σε θυμηθεί:</p>\
                        <div class="form-group form-group--alt"  style="max-width:none;" id="reason_more_wrap">\
                            <label for="moto">Μήνυμα:</label>\
                            <textarea class="form-control" id="history_msg" rows="3"></textarea>\
                        </div>\
                        <div class="btn-wrap justify-content-between">\
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">\
                                <span>ΕΠΙΣΤΡΟΦΗ</span>\
                            </button>\
                            <button type="button" id="history_friend_btn" class="btn btn-primary" data-uid="' + data.uid + '">\
                                <span>ΥΠΟΒΟΛΗ</span>\
                            </button>\
                        </div>\
                    </div>\
                ',
                'Προσθήκη Φίλου'
            );
        }
    };
}();

if (typeof module !== 'undefined') {
    module.exports = ModalRendering;
}
